import React from 'react';

import { PERMISSIONS } from 'api/auth/constants';
import { appReactMemo } from 'hocs';
import { PERMISSION_TYPE, useRBAC } from 'hooks/useRBAC';

import { useFilterContext } from '../../Filters/FilterContext';
import { useOverflowCell } from '../../hooks/useOverflowCell';
import { HelperPopover, HelperPopoverContainer, RowCellContainer } from '../../styled';
import RowCell, { TRowCellData } from '../RowCell';

import { LinkWrapper, StyledLink } from './styled';

interface ICopyCell<T> extends TRowCellData<T> {
  conditionType?: PERMISSION_TYPE;
  onClick?: () => void;
  permissions?: PERMISSIONS[];
  target?: string;
  text?: string;
  to?: string;
}

const LinkCell = <T,>({
  center,
  className,
  conditionType,
  dataKey,
  item,
  onClick,
  permissions,
  rowIndex,
  target,
  text,
  to,
}: ICopyCell<T>) => {
  const { isOverflowed, ref } = useOverflowCell<HTMLAnchorElement>();
  const { checkPermission } = useRBAC();

  const {
    config: { mainColumnsList },
  } = useFilterContext();

  const isCanRedirect = checkPermission({
    conditionType,
    list: permissions,
  });

  if (!text || (permissions && !isCanRedirect)) {
    return (
      <RowCell
        center={center}
        className={className}
        dataKey={dataKey}
        item={item}
        rowIndex={rowIndex}
      />
    );
  }

  return (
    <RowCellContainer
      $center={center}
      $index={rowIndex}
      $isMainColumn={mainColumnsList?.some((column) => column === dataKey)}
      className={className}
      data-testid={`${dataKey as string}Cell`}
    >
      <HelperPopover
        asContainer={HelperPopoverContainer}
        component={text}
        disabled={!isOverflowed}
        immediateAnimation
        openDelay={300}
        positionGap={14}
        showOnClick={false}
      >
        <LinkWrapper>
          <StyledLink
            conditionType={conditionType}
            linkRef={ref}
            onClick={onClick}
            permissions={permissions}
            target={target}
            to={to}
          >
            {text}
          </StyledLink>
        </LinkWrapper>
      </HelperPopover>
    </RowCellContainer>
  );
};

export default appReactMemo(LinkCell);
